<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div *ngIf="!isLoading">
    <div class="certs-header">
        <h3 class="certs-title">Certifications</h3>
        <span class="certs-count">{{activeCerts.length}} active<span *ngIf="historyCerts.length">, {{historyCerts.length}} expired</span></span>
    </div>

    <div *ngIf="!certificates.length" class="no-certs">No certifications found.</div>

    <!-- Active Certs -->
    <div *ngFor="let cert of activeCerts" class="cert-row">
        <div class="cert-row-top">
            <mat-icon class="cert-icon cert-valid">verified</mat-icon>
            <div class="cert-info">
                <span class="cert-title">{{cert.category}}</span>
                <span class="cert-type">{{cert.title}}</span>
            </div>
            <span class="cert-status cert-status-valid">{{cert.status}}</span>
        </div>
        <div class="cert-row-meta">
            <span>{{cert.certDate | date:'MM/dd/yyyy'}} - {{cert.expires | date:'MM/dd/yyyy'}}</span>
        </div>
        <div *ngIf="cert.endorsements?.length" class="cert-endorsements">
            <span class="endorsement-label">Endorsements:</span>
            <span *ngFor="let e of cert.endorsements; let last = last" class="endorsement-item">{{e.name}}<span *ngIf="!last">,</span></span>
        </div>
    </div>

    <!-- History (collapsed) -->
    <mat-expansion-panel *ngIf="historyCerts.length" class="history-panel mt-2">
        <mat-expansion-panel-header>
            <mat-panel-title>Certificate History ({{historyCerts.length}})</mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngFor="let cert of historyCerts" class="cert-row">
            <div class="cert-row-top">
                <mat-icon class="cert-icon cert-expired">cancel</mat-icon>
                <div class="cert-info">
                    <span class="cert-title">{{cert.category}}</span>
                    <span class="cert-type">{{cert.title}}</span>
                </div>
                <span class="cert-status cert-status-expired">{{cert.status}}</span>
            </div>
            <div class="cert-row-meta">
                <span>{{cert.certDate | date:'MM/dd/yyyy'}} - {{cert.expires | date:'MM/dd/yyyy'}}</span>
            </div>
            <div *ngIf="cert.endorsements?.length" class="cert-endorsements">
                <span class="endorsement-label">Endorsements:</span>
                <span *ngFor="let e of cert.endorsements; let last = last" class="endorsement-item">{{e.name}}<span *ngIf="!last">,</span></span>
            </div>
        </div>
    </mat-expansion-panel>
</div>
